import React, { useContext } from 'react';
import './links.scss';

import philosophyIcon from '../../../../assets/philosophy.svg';
import commitmentIcon from '../../../../assets/commitment.svg';
import departmentsIcon from '../../../../assets/departments.svg';
import vTourIcon from '../../../../assets/virtualtour.svg';
import foundationIcon from '../../../../assets/fundacion2-icon.svg';
import anthemIcon from '../../../../assets/himno-icon.svg';

// CONTEXT
import AboutusContext from '../../../../contexts/pages/aboutus/aboutusContext';
import { videoPlayerContext } from '../../../../contexts/helpers/videoPlayer/videoPlayerContext';

async function scrollTo(cb, ms) {
    return new Promise(resolve => {
        setTimeout(cb, ms);
    });
}

const Links = ({ animationStates, linkState, handleCurrentLinkState }) => {

    const aboutusContext = useContext(AboutusContext);
    const { updateAboutusBanner } = aboutusContext;

    const VideoPlayerContext = useContext(videoPlayerContext);
    const { handleActivatePlayer, handleDeactivatePlayer } = VideoPlayerContext;

    const {
        foundationState,
        setFoundationState,
        philosophyState,
        setPhilosophyState,
        departmentsState,
        setDepartmentsState,
        commitmentState,
        setCommitmentState,
        anthemState,
        setAnthemState,
        virtualTourState,
        setVirtualTourState,
    } = animationStates;
    console.log(linkState)
    console.log(animationStates)


    return (
        <div className="aboutus-links">
            <div className="row aboutus-links-row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                foundationLinkState: true,
                                philosophyLinkState: false,
                                departmentsLinkState: false,
                                commitmentLinkState: false,
                                anthemLinkState: false,
                                virtualTourLinkState: false,
                            })
                            handleDeactivatePlayer()
                            updateAboutusBanner('allies')
                            if (document.querySelector(".aboutus-body")) document.querySelector(".aboutus-body").scrollIntoView({ behavior: "smooth", block: "start" });
                            setFoundationState({
                                active:true,
                                enter: true
                            });
                            setPhilosophyState({
                                active: false,
                                enter: false
                            });
                            setDepartmentsState({
                                active: false,
                                enter: false
                            });
                            setCommitmentState({
                                active: false,
                                enter: false
                            });
                            setAnthemState({
                                active: false,
                                enter: false
                            });
                            setVirtualTourState({
                                active: false,
                                enter: false
                            });
                        }}
                    >
                        <div className="aboutus-link" style={linkState.foundationLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img className="icon-svg" src={foundationIcon} style={linkState.foundationLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.foundationLinkState ? { color: "#0a415d" } : {}}>Fundación Pedagógica</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                foundationLinkState: false,
                                philosophyLinkState: true,
                                departmentsLinkState: false,
                                commitmentLinkState: false,
                                anthemLinkState: false,
                                virtualTourLinkState: false,
                            })
                            updateAboutusBanner('philosophy')
                            if (document.querySelector(".aboutus-body")) document.querySelector(".aboutus-body").scrollIntoView({ behavior: "smooth", block: "start" });
                            setFoundationState({
                                active: false,
                                enter: false,
                            });
                            setPhilosophyState({
                                active:true,
                                enter: true
                            });
                            setDepartmentsState({
                                active: false,
                                enter: false
                            });
                            setCommitmentState({
                                active: false,
                                enter: false
                            });
                            setAnthemState({
                                active: false,
                                enter: false
                            });
                            setVirtualTourState({
                                active: false,
                                enter: false
                            });
                            handleDeactivatePlayer()
                        }}
                    >
                        <div className="aboutus-link" style={linkState.philosophyLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                <img className="icon-svg" src={philosophyIcon} style={linkState.philosophyLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.philosophyLinkState ? { color: "#0a415d" } : {}}>Filosofía Institucional</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                foundationLinkState: false,
                                philosophyLinkState: false,
                                departmentsLinkState: true,
                                commitmentLinkState: false,
                                anthemLinkState: false,
                                virtualTourLinkState: false,
                            })
                            handleDeactivatePlayer()
                            updateAboutusBanner('departments')
                            if (document.querySelector(".aboutus-body")) document.querySelector(".aboutus-body").scrollIntoView({ behavior: "smooth", block: "start" });
                            setFoundationState({
                                active: false,
                                enter: false
                            });
                            setPhilosophyState({
                                active: false,
                                enter: false
                            });
                            setDepartmentsState({
                               active:true,
                                enter: true
                            });
                            setCommitmentState({
                                active: false,
                                enter: false
                            });
                            setAnthemState({
                                active: false,
                                enter: false
                            });
                            setVirtualTourState({
                                active: false,
                                enter: false
                            });
                        }}
                    >
                        <div className="aboutus-link" style={linkState.departmentsLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                {/* <i className="fas fa-sitemap"></i> */}
                                <img className="icon-svg" src={departmentsIcon} style={linkState.departmentsLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.departmentsLinkState ? { color: "#0a415d" } : {}}>Organismos y Departamentos</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row aboutus-links-row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                foundationLinkState: false,
                                philosophyLinkState: false,
                                departmentsLinkState: false,
                                commitmentLinkState: true,
                                anthemLinkState: false,
                                virtualTourLinkState: false,
                            })
                            handleDeactivatePlayer()
                            updateAboutusBanner('commitment')
                            if (document.querySelector(".aboutus-body")) document.querySelector(".aboutus-body").scrollIntoView({ behavior: "smooth", block: "start" });
                            setFoundationState({
                                active: false,
                                enter: false
                            });
                            setPhilosophyState({
                                active: false,
                                enter: false
                            });
                            setDepartmentsState({
                                active: false,
                                enter: false
                            });
                            setCommitmentState({
                                active:true,
                                enter: true
                            });
                            setAnthemState({
                                active: false,
                                enter: false
                            });
                            setVirtualTourState({
                                active: false,
                                enter: false
                            });
                        }}
                    >
                        <div className="aboutus-link" style={linkState.commitmentLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                {/* <i className="fas fa-globe-americas"></i> */}
                                <img className="icon-svg" src={commitmentIcon} style={linkState.commitmentLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.commitmentLinkState ? { color: "#0a415d" } : {}}>Compromiso Social</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                                foundationLinkState: false,
                                philosophyLinkState: false,
                                departmentsLinkState: false,
                                commitmentLinkState: false,
                                anthemLinkState: true,
                                virtualTourLinkState: false,
                            })
                            handleDeactivatePlayer()
                            updateAboutusBanner('virtualTools')
                            if (document.querySelector(".aboutus-body")) document.querySelector(".aboutus-body").scrollIntoView({ behavior: "smooth", block: "start" });
                            setFoundationState({
                                active: false,
                                enter: false
                            });
                            setPhilosophyState({
                                active: false,
                                enter: false
                            });
                            setDepartmentsState({
                                active: false,
                                enter: false
                            });
                            setCommitmentState({
                                active: false,
                                enter: false
                            });
                            setAnthemState({
                                active:true,
                                enter: true
                            });
                            setVirtualTourState({
                                active: false,
                                enter: false
                            });
                        }}
                    >
                        <div className="aboutus-link" style={linkState.anthemLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                {/* <i className="fas fa-cogs"></i> */}
                                <img className="icon-svg" src={anthemIcon} style={linkState.anthemLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.anthemLinkState ? { color: "#0a415d" } : {}}>Himno Babeque</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div
                        onClick={() => {
                            handleCurrentLinkState({
                               foundationLinkState: false,
                                philosophyLinkState: false,
                                departmentsLinkState: false,
                                commitmentLinkState: false,
                                anthemLinkState: false,
                                virtualTourLinkState: true,
                            })
                            handleActivatePlayer()
                            scrollTo(() => {
                                if (document.querySelector(".video-player-wrapper"))
                                    document.querySelector(".video-player-wrapper").scrollIntoView({ behavior: "smooth", block: "center" })
                            }, 1200);
                            setFoundationState({
                                active: false,
                                enter: false
                            });
                            setPhilosophyState({
                                active: false,
                                enter: false
                            });
                            setDepartmentsState({
                                active: false,
                                enter: false
                            });
                            setCommitmentState({
                                active: false,
                                enter: false
                            });
                            setAnthemState({
                                active: false,
                                enter: false
                            });
                            setVirtualTourState({
                               active:true,
                                enter: true
                            });
                        }}
                    >
                        <div className="aboutus-link" style={linkState.virtualTourLinkState ? { background: "#fee860" } : {}}>
                            <div className="link-icon">
                                {/* <i className="fas fa-video"></i> */}
                                <img className="icon-svg" src={vTourIcon} style={linkState.virtualTourLinkState ? { filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" } : {}} />
                            </div>
                            <div className="link-text" style={linkState.virtualTourLinkState ? { color: "#0a415d" } : {}}>Tour Virtual</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Links;